import { render, staticRenderFns } from "./ProductPostingList.vue?vue&type=template&id=02eb4bb4&scoped=true"
import script from "./ProductPostingList.vue?vue&type=script&lang=js"
export * from "./ProductPostingList.vue?vue&type=script&lang=js"
import style0 from "./ProductPostingList.vue?vue&type=style&index=0&id=02eb4bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eb4bb4",
  null
  
)

export default component.exports